









import Component from 'vue-class-component'
import { Vue } from 'vue-property-decorator'
import Tax from '@/dto/taxes/Tax'
import TaxFactory from '@/services/factories/TaxFactory'
import TaxForm from '@/components/tax/TaxForm.vue'

@Component({
  components: { TaxForm },
})
export default class TaxCreate extends Vue {
  tax: Tax = TaxFactory()
}
